import { ChangePasswordFormData } from 'types/auth';

export const initialValues: ChangePasswordFormData = {
    password: '',
    confirmPassword: '',
};
